import { createContext, useContext, useState, type ReactNode } from "react";

type Ctx = {
  /** Home: chặn scroll theo hash (splash / overlay load) — SmoothScroll giữ top tới khi false */
  homeHashScrollBlocked: boolean;
  setHomeHashScrollBlocked: (v: boolean) => void;
};

const HomeSplashScrollContext = createContext<Ctx | null>(null);

export function HomeSplashScrollProvider({ children }: { children: ReactNode }) {
  const [homeHashScrollBlocked, setHomeHashScrollBlocked] = useState(() =>
    typeof window !== "undefined" ? window.location.pathname === "/" : false
  );

  return (
    <HomeSplashScrollContext.Provider value={{ homeHashScrollBlocked, setHomeHashScrollBlocked }}>
      {children}
    </HomeSplashScrollContext.Provider>
  );
}

export function useHomeSplashScroll() {
  const ctx = useContext(HomeSplashScrollContext);
  if (!ctx) {
    throw new Error("useHomeSplashScroll must be used within HomeSplashScrollProvider");
  }
  return ctx;
}
